import React, { useEffect, useState } from "react";
import disasterimg from "../../assets/images/disater.svg";
import star from "../../assets/images/star.svg";
import useCurrentUser from "hooks/useCurrentUser";
import { Link } from "react-router-dom";
import { sponsorService } from "services/sponsor.service";
import { toast } from "react-toastify";
import { paymnetService } from "services/payment.service";
import useSponsorRequest from "hooks/useSponserRequest";


const Advertisement = ({ activeTab, dataLength, handleViewMore }) => {
  const { user } = useCurrentUser();
  const [paidEmergencies, setPaidEmergencies] = useState([]);
  const { sponserData } = useSponsorRequest(dataLength);
  const [sponsers, setSponsers] = useState([])

  useEffect(() => {
    setSponsers(sponserData)
  }, [sponserData])

  const handlePayNow = async (sponser) => {
    try {
      const response = await paymnetService.createCheckoutSession({ type: 'SponsorRequest', id: sponser?._id });
      response?.data?.data?.url && window.open(response?.data?.data?.url, '_blank');
    } catch (err) {
      toast.error(err.data.message);
    }
  }

  const handleDeny = async (id) => {
    try {
      const response = await sponsorService.denySponserPayment(id)
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        const updatedSponsers = sponsers?.sponsers?.map(item => {
          if (item?._id === id) {
            return response?.data?.data?.sponsorRequest;
          }
          return item;
        });

        setSponsers({
          totalSponsers: updatedSponsers?.length,
          sponsers: updatedSponsers
        })
      } else {
        toast.warning(response?.data?.message);
      }
    } catch (err) {
      toast.error(err.data.message);
    }
  }
  return (
    <div className="advertise-list">
      {sponserData?.sponsers?.length > 0 ? (<>
        {sponserData?.sponsers?.map((item, i) => {
          return (
            <div className="d-flex flex-wrap emergency-carrds gap-3 justify-content-between" key={item?._id}>
              <Link to={`/advertisement/${item?._id}`}>
                <div className="d-flex align-items-start">
                  <div className="bg-circle me-3">
                    {item?.banner ? (<>
                      <img alt="" src={`${user?.baseS3Url}${item?.banner}`} className="w-50 rounded" />
                    </>) : (
                      <>
                        <img alt="" src={disasterimg} /></>
                    )}
                  </div>
                  <div>
                    <h4>{item?.fullName}</h4>
                    <p>{item?.email}</p>
                  </div>
                </div>
              </Link>
              <div className="d-flex gap-2 ">
                {item?.paymentStatus === "Paid" || paidEmergencies.includes(item?._id) ? (
                  "Paid"
                ) : (
                  item?.paymentStatus === "UserDeny" ? (
                    "Denied"
                  ) : item?.isChargeRequestedByAdmin === true ? (
                    <div className="d-flex  gap-2">
                      <div>
                        <button
                          className="btn pay-btn blue-btn" onClick={() => handlePayNow(item)}>Pay Now</button>
                      </div>
                      <div>
                        <button
                          className="btn pay-btn blue-btn"
                          onClick={() => handleDeny(item?._id)}
                          disabled={paidEmergencies.includes(item?._id)}
                        >
                          Deny
                        </button>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          )
        })}
        {sponsers?.sponsers?.length < sponsers?.totalSponsers && <div className="text-center py-3" style={{ maxWidth: '300px', margin: "auto" }}>
          <button className=" blue-btnnn text-white border-0" onClick={handleViewMore}>
            View More
          </button>
        </div>
        }

      </>) : (
        <div className="outer-white mission-div w-100 mx-auto">
          <div className="mt-2 ">
            <div className="disaster-card mx-auto text-center">
              <div className="alert-distaster mx-auto">
                <img src={star} alt="" />
              </div >
              <h2>No Items Available!</h2>
            </div >
          </div >
        </div >
      )}


    </div>
  );
};

export default Advertisement;
